/** Static copy from Audit Practice Manual (2024 Edition).xlsm — sheets Xi / YZi.
 * These sections are filing indexes only; the manual has no programme sheets. */

import type {SectionIndexRow} from '@/pages/components/audit-program/SectionIndexView';

export type FilingSectionCode = 'X' | 'Y' | 'Z';

export const X_SECTION_PAGES = ['Xi'] as const;
export const Y_SECTION_PAGES = ['Yi'] as const;
export const Z_SECTION_PAGES = ['Zi'] as const;

export const X_SECTION_INDEX: SectionIndexRow[] = [
    {id: 'x-1', kind: 'item', num: '1', title: 'Bank account'},
    {id: 'x-2', kind: 'item', num: '2', title: 'Analysis of receipts'},
    {id: 'x-3', kind: 'item', num: '3', title: 'Unrecorded receipts'},
    {id: 'x-4', kind: 'item', num: '4', title: 'Analysis of payments'},
    {id: 'x-5', kind: 'item', num: '5', title: 'Unrecorded payments'},
    {id: 'x-6', kind: 'item', num: '6', title: 'Cash account'},
    {id: 'x-7', kind: 'item', num: '7', title: 'Analysis of receipts'},
    {id: 'x-8', kind: 'item', num: '8', title: 'Analysis of payments'},
    {id: 'x-9', kind: 'item', num: '9', title: 'Petty cash account'},
    {id: 'x-10', kind: 'item', num: '10', title: 'Summary receipts/payments'},
    {id: 'x-11', kind: 'item', num: '11', title: 'Wages, salaries etc., summary'},
    {id: 'x-12', kind: 'item', num: '12', title: 'Creditors control account'},
    {id: 'x-13', kind: 'item', num: '13', title: 'Debtors control account'},
    {id: 'x-14', kind: 'item', num: '14', title: ''},
    {id: 'x-15', kind: 'item', num: '15', title: ''},
    {id: 'x-16', kind: 'item', num: '16', title: ''},
];

export const Y_SECTION_INDEX: SectionIndexRow[] = [
    {id: 'y-1', kind: 'item', num: '1', title: 'Cash flow statements'},
    {id: 'y-2', kind: 'item', num: '2', title: ''},
    {id: 'y-3', kind: 'item', num: '3', title: ''},
    {id: 'y-4', kind: 'item', num: '4', title: ''},
];

export const Z_SECTION_INDEX: SectionIndexRow[] = [
    {id: 'z-1', kind: 'item', num: '1', title: 'Year end trial balance'},
    {id: 'z-2', kind: 'item', num: '2', title: 'Journals'},
    {id: 'z-3', kind: 'item', num: '3', title: 'General ledger printouts'},
    {id: 'z-4', kind: 'item', num: '4', title: 'Posting summary/data entry'},
    {id: 'z-5', kind: 'item', num: '5', title: 'Opening trial balance'},
    {id: 'z-6', kind: 'item', num: '6', title: 'Summary of records received'},
    {id: 'z-7', kind: 'item', num: '7', title: ''},
    {id: 'z-8', kind: 'item', num: '8', title: ''},
    {id: 'z-9', kind: 'item', num: '9', title: ''},
];
